import { render, staticRenderFns } from "./Reorder.vue?vue&type=template&id=1b671610&"
import script from "./Reorder.vue?vue&type=script&lang=js&"
export * from "./Reorder.vue?vue&type=script&lang=js&"
import style0 from "./Reorder.vue?vue&type=style&index=0&id=1b671610&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports